import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_LABELS, UPDATE_LABELS_SUCCESS, UPDATE_LABELS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* updateLabels({ payload }) {
  const { ticketId } = payload;
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/${ticketId}/labels`,
      method: 'PATCH',
      data: payload.data,
      isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: UPDATE_LABELS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_LABELS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_LABELS_ERROR, payload: error });
  }
}

export function* watchUpdateLabels() {
  yield takeEvery(UPDATE_LABELS, updateLabels);
}

function* updateLabelsSaga() {
  yield all([fork(watchUpdateLabels)]);
}

export default updateLabelsSaga;
